import React from "react";

import "./unauthenticated.css";
import logo from "../../assets/revyz-logo.svg";

const Unauthenticated = () => {
  return (
    <div className="unauthcontainer">
      <img src={logo} alt="revyzlogo" style={{width: "257px", height: "88px"}}/>
      <h1>Unauthorised access</h1>
      <p>
        You can contact your system administrator for more info or create a{" "}
        <a target="_blank" href="https://support.revyz.io/" rel="noreferrer">
          support ticket
        </a>{" "}
      </p>
    </div>
  );
};

export default Unauthenticated;
